module.exports = __webpack_public_path__ + "static/img/12.6391dc4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/5/sp/12.png
// module id = Wgeo
// module chunks = 0